import { useAppSelector } from 'hooks/reduxHooks'
import { getCanRedeemLuxPlusBenefits, getIsPendingRenewalLuxPlusMember } from 'luxPlus/selectors/featureToggle'

/**
 * Whether to show "Become a member" / "Start free preview" CTAs.
 * Returns false for active paid members and pending-renewal (failed payment) members,
 * since they already hold a membership. Free preview and non-members see the CTAs.
 */
function useShouldShowMembershipCta(): boolean {
  const canRedeemBenefits = useAppSelector(getCanRedeemLuxPlusBenefits)
  const isPendingRenewal = useAppSelector(getIsPendingRenewalLuxPlusMember)
  return !canRedeemBenefits && !isPendingRenewal
}

export default useShouldShowMembershipCta
